// This file represents the Ruby AccountOpening::BeneficiaryRelationship enum
// from monorails/app/constants/account_opening/beneficiary_relationship.rb

// The exact values from the Ruby enum
export const BeneficiaryRelationshipValues = [
  'spouse',
  'child',
  'grandchild',
  'parent',
  'sibling',
  'other_individual',
  'trust',
  'organization',
  'estate',
  'grandparent',
  'uncle_aunt',
  'niece_nephew',
  'friend',
] as const;

// Type representing the exact values from the Ruby enum
export type BeneficiaryRelationship = (typeof BeneficiaryRelationshipValues)[number];

// Options array for UI components with proper labels
export const BeneficiaryRelationshipOptions: {
  readonly value: BeneficiaryRelationship;
  readonly label: string;
}[] = [
  { value: 'spouse', label: 'Spouse' },
  { value: 'child', label: 'Child' },
  { value: 'grandchild', label: 'Grandchild' },
  { value: 'parent', label: 'Parent' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'other_individual', label: 'Other Individual' },
  { value: 'trust', label: 'Trust' },
  { value: 'organization', label: 'Organization' },
  { value: 'estate', label: 'Estate' },
  { value: 'grandparent', label: 'Grandparent' },
  { value: 'uncle_aunt', label: 'Uncle / Aunt' },
  { value: 'niece_nephew', label: 'Niece / Nephew' },
  { value: 'friend', label: 'Friend' },
];

export function isEntityRelation(value: string | null | undefined): value is 'trust' | 'organization' | 'estate' {
  return value === 'trust' || value === 'organization' || value === 'estate';
}

export const BeneficiaryRelationshipIndividualOptions = BeneficiaryRelationshipOptions.filter(
  (option) => !isEntityRelation(option.value),
);

// Helper function to check if a string is a valid beneficiary relationship
export function isValidBeneficiaryRelationship(value: string): value is BeneficiaryRelationship {
  return BeneficiaryRelationshipValues.some((validValue) => validValue === value);
}

// Helper function to safely cast a string to BeneficiaryRelationship
export function castToBeneficiaryRelationship(value: string): BeneficiaryRelationship | null {
  return isValidBeneficiaryRelationship(value) ? value : null;
}
